<template>
    <div>
        <div class="col-md-12">
            <form name="newDocument" @submit.prevent="handleSubmit()">
                <div class="modal-body">
                    <label>Subject/Title</label>
                    <input name="SubjectTitle"
                           v-validate="'required|max:255'"
                           v-model="encodingData.SubjectTitle"
                           id="SubjectTitle"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('SubjectTitle') }" />
                    <span v-if="submitted && errors.has('SubjectTitle')"
                          class="invalid-feedback">{{ errors.first("SubjectTitle") }}</span>
                    <!--  -->
                    <label>Report Number</label>
                    <input name="ReportNo"
                           v-validate="'max:50'"
                           v-model="encodingData.ReportNo"
                           id="ReportNo"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('ReportNo') }" />
                    <span v-if="submitted && errors.has('ReportNo')"
                    class="invalid-feedback">{{ errors.first("ReportNo") }}</span>

                    <!--  -->
                    <label>Written By</label>
                    <input name="WrittenBy"
                           v-model="encodingData.WrittenBy"
                           class="form-control" />
                    <!--  -->
                    <label>Report Date</label>
                    <input type="date"
                           :formatter="formatDate"
                           v-validate="'required'"
                           name="ReportDate"
                           v-model="encodingData.ReportDate"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('ReportDate') }" />
                    <span v-if="submitted && errors.has('ReportDate')"
                          class="invalid-feedback">{{ errors.first("ReportDate") }}s</span>
                    <!--  -->
                    <label>Source Office</label>
                    <select name="SourceId"
                            v-validate="'required'"
                            v-model="encodingData.SourceId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('SourceId') }">
                        <option value>Select Source</option>
                        <option v-for="option in sources"
                                v-bind:value="option.sourceID"
                                v-bind:key="option.sourceID">
                            {{ option.sourceName }}
                        </option>
                    </select>
                    <span v-if="submitted && errors.has('SourceId')"
                          class="invalid-feedback">{{ errors.first("SourceId") }}</span>
                    <!--  -->
                    <label>Info Accuracy</label>
                    <select name="InfoAccId"
                            v-validate="'required'"
                            v-model="encodingData.InfoAccId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('InfoAccId') }">
                        <option value>Select Info Accuracy</option>
                        <option v-for="option in infoacc"
                                v-bind:value="option.infoAccID"
                                v-bind:key="option.infoAccID">
                            {{ option.infoAccDesc }}
                        </option>
                    </select>
                    <span v-if="submitted && errors.has('InfoAccId')"
                          class="invalid-feedback">{{ errors.first("InfoAccId") }}</span>
                    <!--  -->
                    <label>File Upload</label>
                    <input v-validate="'ext:doc,docx,pdf'"
                           type="file"
                           name="file"
                           ref="file"
                           class="form-control"
                           :class="{ 'is-invalid': submitted && errors.has('file') }"
                           v-on:change="handleFileUpload()" />
                    <span v-if="submitted && errors.has('file')"
                          class="invalid-feedback">{{ errors.first("file") }}</span>

                    <!--  -->
                    <label>Report Type</label>
                    <select name="ReportType"
                            v-validate="'required'"
                            v-model="encodingData.ReportType"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('ReportType') }">
                        <option value>Select Report</option>
                        <option v-for="option in reports"
                                v-bind:value="option.reportID"
                                v-bind:key="option.reportID">
                            {{ option.reportName }}
                        </option>
                    </select>
                    <span v-if="submitted && errors.has('ReportType')"
                          class="invalid-feedback">{{ errors.first("ReportType") }}</span>
                    <!--  -->
                    <label>Origin Office</label>
                    <select name="OriginId"
                            v-validate="'required'"
                            v-model="encodingData.OriginId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('OriginId') }">
                        <option value>Select Origin</option>
                        <option v-for="option in sources"
                                v-bind:value="option.sourceID"
                                v-bind:key="option.sourceID">
                            {{ option.sourceName }}
                        </option>
                    </select>
                    <span v-if="submitted && errors.has('OriginId')"
                          class="invalid-feedback">{{ errors.first("OriginId") }}</span>
                    <!--  -->
                    <label>Sec Class</label>
                    <select name="SecClassId"
                            v-validate="'required'"
                            v-model="encodingData.SecClassId"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('SecClassId') }">
                        <option value>Select Sec Class</option>
                        <option value="0">NONE</option>
                        <option value="1">RESTRICTED</option>
                        <option value="2">CONFIDENTIAL</option>
                        <option value="3">SECRET</option>
                        <option value="4">TOP SECRET</option>

                    </select>
                    <span v-if="submitted && errors.has('SecClassId')"
                          class="invalid-feedback">
                        {{ errors.first("SecClassId") }}
                    </span>
                    <!--  -->
                    <label>Full Text</label>
                    <textarea name="FullText"
                              v-validate="'required|max:4000'"
                              cols="5"
                              rows="5"
                              v-model="encodingData.FullText"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && errors.has('FullText') }" />
                    <span v-if="submitted && errors.has('FullText')"
                          class="invalid-feedback">{{ errors.first("FullText") }}</span>
                    <!--  -->
                    <label>Major Classification</label>
                    <select name="Major"
                            v-validate="'required'"
                            v-model="encodingData.Major"
                            class="form-control"
                            :class="{ 'is-invalid': submitted && errors.has('Major') }">
                        <option value>Select Major Classification</option>
                        <option v-for="option in majorc"
                                v-bind:value="option.major"
                                v-bind:key="option.docClasID">
                            {{ option.major }}
                        </option>
                    </select>
                    <span v-if="submitted && errors.has('Major')"
                          class="invalid-feedback">
                        {{ errors.first("Major") }}
                    </span>
                    <!--  -->
                    <label>Minor Classification</label>
                    <select name="Minor"
                            v-model="encodingData.Minor"
                            class="form-control">
                        <option value>Select Minor Classification</option>
                        <option v-for="option in minorc"
                                v-bind:value="option.minor"
                                v-bind:key="option.docClasID">
                            {{ option.minor }}
                        </option>
                    </select>

                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">Update</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        notifyHelper,
        RecordURL,
        DataURL,
        EncodeURL,
        getlocalstorageSources,
        getlocalstorageInfoAcc,
        getLocalstorageMajorClassification,
        formatdate,
    } from "../../helper";
    import instance from "../../helper/http";
    export default {
        data() {
            return {
                encodingData: {
                    DocumentId: "",
                    SubjectTitle: "",
                    ReportNo: "",
                    WrittenBy: "",
                    ReportDate: "",
                    SourceId: "",
                    InfoAccId: "",
                    ReportType: "",
                    SecClassId: "",
                    OriginId: "",
                    FullText: "",
                    FileName: "",
                    Major: "",
                    Minor: ""
                },
                sources: [],
                infoacc: [],
                reports: [],
                majorc: [],
                minorc: [],
                submitted: false,
                file: "",
            };
        },
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        created: function () {
            this.getSources();
            //get the record
        },
        watch: {
            "encodingData.SourceId": function (id) {
                this.SourceChange(id);
            },
            "encodingData.Major": function (Major) {
                this.MajorChange(Major);
            }
        },
        filters: {},
        methods: {
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
                if (this.file.size > 21966080) {
                    notifyHelper("warn", "file size limit reach. Max of 20MB only")
                    this.file = "";
                    return;
                }
            },
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate().then((valid) => {
                    if (this.file.size > 21966080) {
                        notifyHelper("warn", "file size limit reach. Max of 20MB only")
                        this.file = "";
                        return;
                    }
                    if (valid) {
                        let formData = new FormData();
                        formData.append("file", this.file);
                        formData.append("DocumentDetails", JSON.stringify(this.encodingData));
                        let loader = this.$loading.show();
                        instance
                            .post(EncodeURL + "updateDocument", formData, {
                                headers: authHeader(),
                            })
                            .then((response) => {
                                if (response.data.error) {
                                    loader.hide();
                                    notifyHelper("error", response.data.message);
                                } else {
                                    loader.hide();
                                    notifyHelper("success", response.data.message);
                                    this.$emit("done-edit");
                                }
                            })
                            .catch(function (error) {
                                responseCheck(error.response.status);
                            });
                    }
                });
            },
            getSources() {
                this.sources = getlocalstorageSources();
                this.infoacc = getlocalstorageInfoAcc();
                this.majorc = getLocalstorageMajorClassification();
                this.getDocument();
            },
            SourceChange(id) {
                instance
                    .get(RecordURL + "reportid?id=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.reports = response.data;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    })
                    
            },
            MajorChange(Major) {
                instance
                    .get(EncodeURL + "MinorClassification?Major=" + Major, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.minorc = response.data.data;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getDocument() {
                instance
                    .get(DataURL + "document?documentID=" + this.id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.error === false) {
                            if (response.data.withdata) {
                                let data = response.data.data;
                                let classification = response.data.classification;
                                this.encodingData.DocumentId = data.documentId;
                                this.encodingData.SubjectTitle = data.subjectTitle;
                                this.encodingData.ReportNo = data.reportNo;
                                this.encodingData.WrittenBy = data.writtenBy;
                                this.encodingData.ReportDate = formatdate(data.reportDate);
                                this.encodingData.SourceId = data.sourceId;
                                this.encodingData.InfoAccId = data.infoAccId;
                                this.encodingData.ReportType = data.reportType;
                                this.encodingData.SecClassId = data.secClassId.toString();
                                this.encodingData.OriginId = data.originId;
                                this.encodingData.FullText = data.fullText;
                                if (classification != null) {
                                    this.encodingData.Major = classification.major;
                                    this.encodingData.Minor = classification.minor;
                                }
                                
                            }
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
        },
    };
</script>

